<template>
  <v-dialog
    v-model="computedBikeparkBridgesVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <!-- close icon -->
        <v-btn
          icon
          @click="
            methodToggleSingleLayer('bikepark', 'bridges', false);
            date = null;
            base64image = null;
            disable_edit = true;
          "
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span>{{ computedName }} {{ computedLoc }}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            @click="
              zoomTo({
                center: computedLatLng[0].geometry.coordinates[0],
                level: 18
              });
              // check if map layer is visible, toggle on if not so when we zoom to location
              // there is a dot to zoom to
              methodCloseListLayer('bikepark', 'bridges');
              methodToggleSingleLayer('bikepark', 'bridges', false);
            "
          >
            <v-icon>map</v-icon>
          </v-btn>
          <span>See on map</span>
        </v-tooltip>
        <!-- delete icon -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            :disabled="disable_edit"
            @click="confirm_delete = true"
          >
            <v-icon>delete</v-icon>
          </v-btn>
          <span>Delete</span>
        </v-tooltip>

        <!-- edit icon -->
        <v-tooltip bottom>
          <v-btn
            :color="disable_edit ? '' : 'primary'"
            icon
            slot="activator"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="
              disable_edit = !disable_edit;
              base64image = null;
            "
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <span>Edit</span>
        </v-tooltip>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :items="computedBikeparkBridgesGeoJsonFeature"
          :loading="computedBikeparkBridgessLoading"
          :hide-actions="hideactions"
          :hide-headers="hideheaders"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td colspan="2">
                <span
                  v-if="
                    computedImageUrl !=
                      'https://api2.alchemymapping.com/images/null'
                  "
                >
                  <img
                    style="max-height: 90vh; max-width: 90vw;"
                    :src="computedImageUrl"
                  />
                </span>
              </td>
            </tr>
            <tr v-if="!disable_edit">
              <td>Update Image</td>
              <td>
                <image-uploader
                  @input="methodSetOutput"
                  :quality="0.7"
                  :autoRotate="attemptAutoRotate"
                  outputFormat="base64"
                  class="fileinput2"
                  :preview="true"
                  accept=".jpg"
                  :key="attemptAutoRotate"
                />
              </td>
            </tr>
            <tr v-if="!disable_edit">
              <td>EXIF rotate?</td>
              <td><v-checkbox v-model="attemptAutoRotate" class="mt-2" /></td>
            </tr>
            <tr>
              <td>Zone</td>
              <td>
                <v-select
                  ref="ref_zone"
                  :items="opt_zone"
                  v-model="props.item.properties.zone"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Trail Name</td>
              <td>
                <v-autocomplete
                  ref="ref_trail_name"
                  v-model="props.item.properties.trail_name"
                  :items="computedUniqueTrailNames"
                  :disabled="disable_edit"
                ></v-autocomplete>
              </td>
            </tr>
            <tr>
              <td>Bridge Number</td>
              <td>
                <v-text-field
                  ref="ref_bridge_num"
                  v-model="props.item.properties.bridge_num"
                  :disabled="disable_edit"
                />
              </td>
            </tr>
            <tr>
              <td>Date Inspected</td>
              <td>
                <v-menu
                  ref="menu_dt_inspect"
                  v-model="menu_dt_inspect"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      ref="ref_dt_inspect"
                      v-model="props.item.properties.dt_inspect"
                      :disabled="disable_edit"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="props.item.properties.dt_inspect"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_dt_inspect = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_dt_inspect.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </td>
            </tr>
            <tr>
              <td>Inspected by</td>
              <td>
                <v-text-field
                  ref="ref_inspector"
                  v-model="props.item.properties.inspector"
                  :disabled="disable_edit"
                />
              </td>
            </tr>
            <tr>
              <td>Date Built</td>
              <td>
                <v-menu
                  ref="menu_dt_blt"
                  v-model="menu_dt_blt"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      ref="ref_dt_blt"
                      v-model="props.item.properties.dt_blt"
                      :disabled="disable_edit"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="props.item.properties.dt_blt"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu_dt_blt = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_dt_blt.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </td>
            </tr>
            <tr>
              <td>Max Load</td>
              <td>
                <v-select
                  ref="ref_max_load"
                  :items="opt_max_load"
                  v-model="props.item.properties.max_load"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Foundation</td>
              <td>
                <v-select
                  ref="ref_foundation"
                  :items="opt_1to5"
                  v-model="props.item.properties.foundation"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Cribbing</td>
              <td>
                <v-select
                  ref="ref_cribbing"
                  :items="opt_1to5"
                  v-model="props.item.properties.cribbing"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Sills</td>
              <td>
                <v-select
                  ref="ref_sills"
                  :items="opt_1to5"
                  v-model="props.item.properties.sills"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Sills Wood Type</td>
              <td>
                <v-select
                  ref="ref_s_wood_typ"
                  :items="opt_s_wood_typ"
                  v-model="props.item.properties.s_wood_typ"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Stringers</td>
              <td>
                <v-select
                  ref="ref_stringers"
                  :items="opt_1to5"
                  v-model="props.item.properties.stringers"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Stringer Wood Type</td>
              <td>
                <v-select
                  ref="ref_st_wood_ty"
                  :items="opt_s_wood_typ"
                  v-model="props.item.properties.st_wood_ty"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Railings</td>
              <td>
                <v-select
                  ref="ref_railings"
                  :items="opt_1to5"
                  v-model="props.item.properties.railings"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Decking</td>
              <td>
                <v-select
                  ref="ref_decking"
                  :items="opt_1to5"
                  v-model="props.item.properties.decking"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Need Vehicle Sign?</td>
              <td>
                <v-select
                  ref="ref_need_v_sig"
                  :items="opt_yes_no"
                  v-model="props.item.properties.need_v_sig"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Need Bridge # Sign?</td>
              <td>
                <v-select
                  ref="ref_need_num_s"
                  :items="opt_yes_no"
                  v-model="props.item.properties.need_num_s"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Notes</td>
              <td>
                <v-textarea
                  ref="ref_notes"
                  v-model="props.item.properties.notes"
                  :disabled="disable_edit"
                ></v-textarea>
              </td>
            </tr>
          </template>
          <template slot="footer">
            <tr>
              <td colspan="100%">
                <v-spacer class="hidden-sm-and-down"></v-spacer>
                <v-btn
                  v-if="base64image"
                  @click.stop="
                    methodEditImageBikeparkBridgesGeoJson({
                      zone: $refs.ref_zone.value,
                      trail_name: $refs.ref_trail_name.value,
                      bridge_num: $refs.ref_bridge_num.value,
                      dt_inspect: $refs.ref_dt_inspect.value,
                      inspector: $refs.ref_inspector.value,
                      dt_blt: $refs.ref_dt_blt.value,
                      max_load: $refs.ref_max_load.value,
                      foundation: $refs.ref_foundation.value,
                      cribbing: $refs.ref_cribbing.value,
                      sills: $refs.ref_sills.value,
                      s_wood_typ: $refs.ref_s_wood_typ.value,
                      stringers: $refs.ref_stringers.value,
                      st_wood_ty: $refs.ref_st_wood_ty.value,
                      railings: $refs.ref_railings.value,
                      decking: $refs.ref_decking.value,
                      need_v_sig: $refs.ref_need_v_sig.value,
                      need_num_s: $refs.ref_need_num_s.value,
                      notes: $refs.ref_notes.value
                    });
                    disable_edit = true;
                    methodToggleSingleLayer('bikepark', 'bridges', false);
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >
                <v-btn
                  v-else
                  @click.stop="
                    methodEditBikeparkBridgesGeoJson({
                      zone: $refs.ref_zone.value,
                      trail_name: $refs.ref_trail_name.value,
                      bridge_num: $refs.ref_bridge_num.value,
                      dt_inspect: $refs.ref_dt_inspect.value,
                      inspector: $refs.ref_inspector.value,
                      dt_blt: $refs.ref_dt_blt.value,
                      max_load: $refs.ref_max_load.value,
                      foundation: $refs.ref_foundation.value,
                      cribbing: $refs.ref_cribbing.value,
                      sills: $refs.ref_sills.value,
                      s_wood_typ: $refs.ref_s_wood_typ.value,
                      stringers: $refs.ref_stringers.value,
                      st_wood_ty: $refs.ref_st_wood_ty.value,
                      railings: $refs.ref_railings.value,
                      decking: $refs.ref_decking.value,
                      need_v_sig: $refs.ref_need_v_sig.value,
                      need_num_s: $refs.ref_need_num_s.value,
                      notes: $refs.ref_notes.value
                    });
                    disable_edit = true;
                    methodToggleSingleLayer('bikepark', 'bridges', false);
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >

                <v-spacer class="hidden-sm-and-down"></v-spacer>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
    <!-- Delete confirmation dialog -->
    <v-dialog v-model="confirm_delete" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Are you sure? This is permanent.</span>
        </v-card-title>
        <v-card-actions>
          <!-- confirm delete button -->
          <v-btn
            color="error"
            flat
            @click.stop="
              confirm_delete = false;
              disable_edit = true;
              methodDeleteBikeparkBridgesGeoJson();
              methodToggleSingleLayer('bikepark', 'bridges', false);
            "
            >Delete</v-btn
          >
          <!-- Cancel button -->
          <v-btn color="primary" flat @click.stop="confirm_delete = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<style scoped>
table {
  padding-top: 20px;
}
</style>
<script>
export default {
  data() {
    return {
      base64image: null,
      attemptAutoRotate: false,
      date: null,
      menu_dt_inspect: false,
      menu_dt_blt: false,
      disable_edit: true,
      confirm_delete: false,
      loading: true,
      persistent: false,
      hideheaders: true,
      hideactions: true,
      solo: true,
      opt_zone: [
        { text: "Creekside" },
        { text: "Fitzsimmons" },
        { text: "Garbanzo" },
        { text: "Peak" }
      ],
      opt_max_load: [
        { text: "Bike" },
        { text: "UTV" },
        { text: "Heavy Machinery" }
      ],
      opt_1to5: [
        { text: 1 },
        { text: 2 },
        { text: 3 },
        { text: 4 },
        { text: 5 }
      ],
      opt_s_wood_typ: [
        { text: "Cedar" },
        { text: "Balsam" },
        { text: "Fir" },
        { text: "Hemlock" },
        { text: "Other" }
      ],
      opt_yes_no: [{ text: "Yes" }, { text: "No" }]
    };
  },
  computed: {
    computedLatLng() {
      if (this.computedBikeparkBridgesVisibility) {
        const bridges = this.$store.state.mapLayers.bikepark.layers.bridges
          .geojson.features;
        const result = bridges.filter(
          item => item.properties.id == this.computedBikeparkBridgesId
        );
        return result;
      }
      return [];
    },
    computedName() {
      let res;
      if (this.computedBikeparkBridgesVisibility) {
        const points = this.$store.state.mapLayers.bikepark.layers.bridges
          .geojson.features;
        // grabs the lift_name of the currently viewed ID
        let result = points.filter(
          item => item.properties.id == this.computedBikeparkBridgesId
        );
        res = result[0].properties.trail_name;
      }
      return res;
    },
    computedLoc() {
      let res;
      if (this.computedBikeparkBridgesVisibility) {
        const points = this.$store.state.mapLayers.bikepark.layers.bridges
          .geojson.features;
        // grabs the lift_name of the currently viewed ID
        let result = points.filter(
          item => item.properties.id == this.computedBikeparkBridgesId
        );
        res = result[0].properties.sign_loc;
      }
      return res;
    },
    computedUniqueTrailNames() {
      const trail_names = this.$store.state.mapLayers.bikepark.layers.bridges
        .geojson.features;
      const trailNames = [];
      trail_names.map(item => {
        trailNames.push(item.properties.trail_name);
      });
      const uniqueTrails = Array.from(new Set(trailNames));
      let finalResults = [];
      uniqueTrails.map(item => {
        finalResults.push({
          text: item
        });
      });
      return finalResults.sort((a, b) => (a.text < b.text ? -1 : 1));
    },
    computedBikeparkBridgesGeoJsonFeature() {
      let res;
      if (
        this.$store.state.mapLayers.bikepark.layers.bridges.geojson.features
      ) {
        const points = this.$store.state.mapLayers.bikepark.layers.bridges
          .geojson.features;
        const result = points.filter(
          item => item.properties.id == this.computedBikeparkBridgesId
        );
        res = result;
      }
      return res;
    },
    computedBikeparkBridgesVisibility() {
      return this.$store.state.mapLayers.bikepark.layers.bridges.visibility
        .singleView;
    },
    computedBikeparkBridgessLoading() {
      return this.$store.state.mapLayers.bikepark.layers.bridges.loading;
    },
    computedBikeparkBridgesId() {
      return this.$store.state.mapLayers.bikepark.layers.bridges.visibility
        .singleId;
    },
    computedImageUrl() {
      if (this.$store.state.ui.image.filename.filename) {
        return (
          "https://api2.alchemymapping.com/images/" +
          this.$store.state.ui.image.filename.filename.filename
        );
      } else {
        return "https://api2.alchemymapping.com/images/null";
      }
    },
    computedImageHack() {
      if (this.$store.state.ui.image.filename.filename) {
        return this.$store.state.ui.image.filename.filename.filename;
      } else {
        return null;
      }
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodSetOutput(file) {
      this.base64image = file;
    },
    methodCloseListLayer(dept, layer) {
      this.$store.commit("mutationCloseListLayer", {
        dept: dept,
        layer: layer
      });
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      return y + "-" + m + "-" + d;
    },
    // method to get geojson
    methodGetBikeparkBridgesGeoJson() {
      console.log("getting");
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/bikepark/bridges",
        dept: "bikepark",
        layer: "bridges",
        token: this.computedAuthToken
      });
    },
    methodEditBikeparkBridgesGeoJson(data) {
      this.$store
        .dispatch("actionEditGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/bikepark/bridges/" +
            this.computedBikeparkBridgesId,
          dept: "bikepark",
          layer: "bridges",
          token: this.computedAuthToken,
          payload: data
        })
        .then(() => {
          // this is a dirty, dirty hack that needs to change.
          // there's a bug where the watcher in bikepark bridges layer
          // isn't firing when the geojson updates...
          this.$store.commit("mutationMapLayer", {
            dept: "bikepark",
            layer: "bridges"
          });
          setTimeout(() => {
            this.$store.commit("mutationMapLayer", {
              dept: "bikepark",
              layer: "bridges"
            });
          }, 250);
          //this.methodGetBikeparkBridgesGeoJson();
        });
    },
    methodEditImageBikeparkBridgesGeoJson(data) {
      this.$store
        .dispatch("actionEditJsonImage", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/bikepark/bridges/" +
            this.computedBikeparkBridgesId,
          imageUrl:
            "https://api2.alchemymapping.com/vail/whistler/bikepark/bridges/image",
          base64data: this.base64image,
          dept: "bikepark",
          layer: "bridges",
          token: this.computedAuthToken,
          payload: data,
          belongstoid: this.computedBikeparkBridgesId
        })
        .then(() => {
          this.base64image = null;
        });
    },
    methodDeleteBikeparkBridgesGeoJson() {
      this.$store
        .dispatch("actionDeleteGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/bikepark/bridges/" +
            this.computedBikeparkBridgesId,
          dept: "bikepark",
          layer: "bridges",
          token: this.computedAuthToken
        })
        .then(
          setTimeout(() => {
            this.methodGetBikeparkBridgesGeoJson();
          }, 250)
        );
    },
    methodGetBikeparkImage() {
      this.$store.dispatch("actionGetImage", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/bikepark/bridges/image/" +
          this.computedBikeparkBridgesId,
        token: this.computedAuthToken
      });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.bikepark.layers.bridges.visibility.singleView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetBikeparkBridgesGeoJson();
        this.methodGetBikeparkImage();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.bikepark.layers.bridges.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
